/**
 * VideoAdClient — lifecycle abstraction for modern in-stream ads.
 * Null client is the production default (no requests, no SDK).
 */

import { VideoAdLifecycle } from "./VideoAdLifecycle";

/**
 * @typedef {object} VideoAdClient
 * @property {string} name
 * @property {function(object=): Promise<void>} init
 * @property {function(object): Promise<object>} requestAds
 * @property {function(): void} destroy
 * @property {function(string, function): function} on
 */

/**
 * @param {object} [options]
 * @param {function} [options.onEvent]
 * @returns {VideoAdClient}
 */
export function createNullVideoAdClient(options) {
  options = options || {};
  var listeners = {};

  function emit(name, payload) {
    var list = listeners[name] || [];
    for (var i = 0; i < list.length; i++) {
      try {
        list[i](payload || {});
      } catch (e) {
        /* ignore listener errors */
      }
    }
    if (typeof options.onEvent === "function") {
      options.onEvent(name, payload || {});
    }
  }

  return {
    name: "null",
    init: function () {
      return Promise.resolve();
    },
    requestAds: function (request) {
      emit(VideoAdLifecycle.AD_REQUEST, { request: request || {} });
      emit(VideoAdLifecycle.AD_NO_FILL, {
        reason: "modern_video_ads_disabled",
      });
      return Promise.resolve({ filled: false, reason: "disabled" });
    },
    destroy: function () {},
    on: function (eventName, handler) {
      if (!listeners[eventName]) listeners[eventName] = [];
      listeners[eventName].push(handler);
      return function unsubscribe() {
        listeners[eventName] = (listeners[eventName] || []).filter(function (h) {
          return h !== handler;
        });
      };
    },
  };
}

export default createNullVideoAdClient;
